import { SITE_URL } from '../constants'

const getCssBanner = () => `/***************************************************
 * Generated by SVG Artista on ${new Date().toLocaleString('en-US')}
 * MIT license (https://opensource.org/licenses/MIT)
 * W. ${SITE_URL}
 **************************************************/
`

export default getCssBanner
